export interface TradeFormValues {
  securityCodeType: SecurityCodeTypeEnum
  symbol: string
  action?: TradeActionEnum
  quantity?: number
  executionPrice?: number
  capacity?: CapacityEnum
  instrumentType: InstrumentTypeEnum
  tradeType: TradeTypeEnum
  listingCountry: listingCountryEnum
  currency: CurrencyEnum
  tradeDate: string
  tradeTime?: string
  settlementType: SettlementTypeEnum
  settlementDate: string
  memo: string
  accountType: AccountTypeEnum
  repCode: string
  routeType?: RouteTypeEnum
  orderId?: string
  market?: MarketEnum
  executingBroker?: string
  sourceAccountNumber?: string
  sourceAccountType?: AccountTypeEnum
  executionAlgorithm?: ExecutionAlgorithmEnum
  commission?: number
  markUpMarkDown?: number
  clientClearingFee?: number
  generalPurposeFee?: number
  liquidityFee?: number
  tradeActivityFee?: number
  specialInstructions?: SpecialInstruction[]
  lotMatchingInstructions?: LotMatchingInstruction[]
}

export enum AccountTypeEnum {
  Cash = 'CASH',
  Margin = 'MARGIN',
  Dvp = 'DVP',
  Short = 'SHORT',
}
export interface TradeFormErrors {
  repCode?: string
  securityCodeType?: string
  symbol?: string
  action?: string
  quantity?: string
  executionPrice?: string
  capacity?: string
  instrumentType?: string
  tradeType?: string
  listingCountry?: string
  currency?: string
  tradeDate?: string
  tradeTime?: string
  settlementType?: string
  settlementDate?: string
  memo?: string
  orderId?: string
  executingBroker?: string
  commission?: string
  markUpMarkDown?: string
  clientClearingFee?: string
  generalPurposeFee?: string
  liquidityFee?: string
  tradeActivityFee?: string
  routeType?: string
  executionAlgorithm?: string
  sourceAccountNumber?: string
  sourceAccountType?: string
  lotMatchingInstructions?: string
}

export enum TradeActionEnum {
  Buy = 'Buy',
  Sell = 'Sell',
  BuyToCover = 'Buy to Cover',
  ShortSell = 'Short Sell',
  SellToOpen = 'Sell To Open',
  SellToClose = 'Sell To Close',
  BuyToOpen = 'Buy To Open',
  BuyToClose = 'Buy To Close',
}

export enum ShortTypeEnum {
  Cover = 'COVER',
  Short = 'SHORT',
}

export enum SideTypeEnum {
  Buy = 'BUY',
  Sell = 'SELL',
}

export enum InstrumentTypeEnum {
  equity = 'EQUITY',
  option = 'OPTION',
}

export enum CapacityEnum {
  agent = 'AGENT',
  principle = 'PRINCIPAL',
  mixed = 'MIXED',
}

export enum SecurityCodeTypeEnum {
  tickerSymbol = 'TICKER_SYMBOL',
  cusip = 'CUSIP',
  isin = 'ISIN',
  occSymbol = 'OCC_SYMBOL',
  sedol = 'SEDOL',
}

export enum TradeTypeEnum {
  allocation = 'ALLOCATION',
  execution = 'EXECUTION',
  awayTrade = 'AWAY_EXECUTION',
}

export enum CurrencyEnum {
  cad = 'CAD',
  usd = 'USD',
}

export enum listingCountryEnum {
  UnitedStates = 'USA',
  Canada = 'CAN',
}

export enum SettlementTypeEnum {
  regularSettlement = 'Regular Settlement',
  specialSettlement = 'Special Settlement',
}

export enum OpenCloseEnum {
  Open = 'OPEN',
  Close = 'CLOSE',
}
export interface TradeActionType {
  value: TradeActionEnum
  text: string
}
export interface SecurityCodeType {
  value: SecurityCodeTypeEnum
  text: string
}
export interface Capacity {
  value: CapacityEnum
  text: string
}
export interface InstrumentType {
  value: InstrumentTypeEnum
  text: string
}
export interface TradeType {
  value: TradeTypeEnum
  text: string
}
export interface Currency {
  value: CurrencyEnum
  text: string
}
export interface SettlementType {
  value: SettlementTypeEnum
  text: string
}

export enum RouteTypeEnum {
  Dma = 'DMA',
  Mngd = 'MNGD',
  Quik = 'QUIK',
  Algo = 'ALGO',
  Away = 'AWAY',
  Corr = 'CORR',
}

export enum MarketEnum {
  Amex = 'AMEX',
  Arca = 'ARCA',
  Bats = 'BATS',
  BatsByx = 'BATS_BYX',
  Boston = 'BOSTON',
  Box = 'BOX',
  Bzx = 'BZX',
  C2 = 'C2',
  Cboe = 'CBOE',
  Chicago = 'CHICAGO',
  Cincinnati = 'CINCINNATI',
  Edga = 'EDGA',
  Edgx = 'EDGX',
  Exclearing = 'EXCLEARING',
  Iex = 'IEX',
  Ise = 'ISE',
  IseGemini = 'ISE_GEMINI',
  Miax = 'MIAX',
  Nasdaq = 'NASDAQ',
  NasdaqOmxBx = 'NASDAQ_OMX_BX',
  Nyse = 'NYSE',
  Otc = 'OTC',
  Phlx = 'PHLX',
}

export const MarketDisplay = {
  [MarketEnum.Amex]: 'AMEX - American Stock Exchange',
  [MarketEnum.Arca]: 'ARCA - NYSE Arca',
  [MarketEnum.Bats]: 'BATS - BATS Equity Exchange',
  [MarketEnum.BatsByx]: 'BATS_BYX - BATS BYX Equity Exchange',
  [MarketEnum.Boston]: 'BOSTON - Boston Stock Exchange',
  [MarketEnum.Box]: 'BOX - BOX Options Exchange',
  [MarketEnum.Bzx]: 'BZX - BATS Options Exchange',
  [MarketEnum.C2]: 'C2 - C2 Options Exchange',
  [MarketEnum.Cboe]: 'CBOE - CBOE Options Exchange',
  [MarketEnum.Chicago]: 'CHICAGO - Chicago Stock Exchange',
  [MarketEnum.Cincinnati]: 'CINCINNATI - Cincinnati Stock Exchange',
  [MarketEnum.Edga]: 'EDGA - BATS Direct Edge A',
  [MarketEnum.Edgx]: 'EDGX - BATS Direct Edge X',
  [MarketEnum.Exclearing]: 'EXCLEARING - Ex Clearing',
  [MarketEnum.Iex]: 'IEX - The Investors Exchange',
  [MarketEnum.Ise]: 'ISE - ISE Options Exchange',
  [MarketEnum.IseGemini]: 'ISE_GEMINI - ISE Gemini Exchange',
  [MarketEnum.Miax]: 'MIAX - MIAX Options Exchange',
  [MarketEnum.Nasdaq]: 'NASDAQ - NASDAQ Exchange',
  [MarketEnum.NasdaqOmxBx]: 'NASDAQ_OMX_BX - NASDAQ OMX BX Exchange',
  [MarketEnum.Nyse]: 'NYSE - New York Stock Exchange',
  [MarketEnum.Otc]: 'OTC - Over the counter execution',
  [MarketEnum.Phlx]: 'PHLX - NASDAQ OMX PHLX',
}

export enum ExecutionAlgorithmEnum {
  Cbrag = 'CBRAG',
  Isg = 'ISG',
  Nhawkg = 'NHAWKG',
  Partg = 'PARTG',
  Trgtclg = 'TRGTCLG',
  Trgtopng = 'TRGTOPNG',
  Twapg = 'TWAPG',
  Vwapg = 'VWAPG',
}

export const ExecutionAlgorithmDisplay = {
  [ExecutionAlgorithmEnum.Cbrag]: 'CBRAG - Cobra',
  [ExecutionAlgorithmEnum.Isg]: 'ISG - Implementation Shortfall',
  [ExecutionAlgorithmEnum.Nhawkg]: 'NHAWKG - Nighthawk',
  [ExecutionAlgorithmEnum.Partg]: 'PARTG - Volume Participation',
  [ExecutionAlgorithmEnum.Trgtclg]: 'TRGTCLG - Target Close',
  [ExecutionAlgorithmEnum.Trgtopng]: 'TRGTOPNG - Target Open',
  [ExecutionAlgorithmEnum.Twapg]: 'TWAPG - Time Weighted Avg Price',
  [ExecutionAlgorithmEnum.Vwapg]: 'VWAPG - Volume Weighted Avg Price',
}

export interface listingCountryType {
  value: listingCountryEnum
  text: string
}

export interface TradeFormTouched {
  securityCodeType?: boolean
  symbol?: boolean
  action?: boolean
  quantity?: boolean
  executionPrice?: boolean
  capacity?: boolean
  instrumentType?: boolean
  tradeType?: boolean
  listingCountry?: boolean
  currency?: boolean
  tradeDate?: boolean
  tradeTime?: boolean
  settlementType?: boolean
  settlementDate?: boolean
  memo?: boolean
  accountType?: boolean
  repCode?: boolean
  orderId?: boolean
  executingBroker?: boolean
  commission?: boolean
  markUpMarkDown?: boolean
  clientClearingFee?: boolean
  generalPurposeFee?: boolean
  liquidityFee?: boolean
  tradeActivityFee?: boolean
  routeType?: boolean
  executionAlgorithm?: boolean
  sourceAccountNumber?: boolean
  sourceAccountType?: boolean
  lotMatchingInstructions?: boolean
}

export interface Fee {
  amount: number
  type: FeeType
}

export enum FeeType {
  ClientClearing = 'CLIENT_CLEARING',
  GeneralPurpose = 'GENERAL_PURPOSE',
  Liquidity = 'LIQUIDITY',
  TradeActivity = 'TRADE_ACTIVITY',
}

export interface Charges {
  commissionAmount?: number
  fees?: Fee[]
  netAmount?: number
  priceAdjustmentAmount?: number
  principalAmount?: number
}

export interface SubmissionPayload {
  correspondent: string
  externalId: string
  id?: string
  charges?: Charges
  instrument: {
    instrumentId: {
      id: string
      listingCountry: listingCountryEnum
      type: SecurityCodeTypeEnum
    }
    type: InstrumentTypeEnum
  }
  reporting?: {
    memo?: string
    repCode?: string
    specialInstructions?: SpecialInstructionsEnum[] | undefined
  }
  settlementInstructions: {
    settlementDate?: string
  }
  transaction: {
    accountNumber: string
    accountType: AccountTypeEnum
    brokerCapacity?: CapacityEnum
    currency: CurrencyEnum
    lotMatchingInstructions?: LotMatchingInstruction[] | undefined
    openClose?: OpenCloseEnum
    price: number
    quantity: number
    side: {
      shortType?: ShortTypeEnum
      type?: SideTypeEnum
    }
    transactionDateTime: string
    type: TradeTypeEnum
    sourceAccountNumber?: string //required only for allocation type
    sourceAccountType?: AccountTypeEnum //Allocation type only
    route?: {
      type?: RouteTypeEnum
      algorithmType?: string // this needs to become an enum. required when type is ALGO
    }
    exchange?: MarketEnum // Required when route.type = AWAY or DMA
    executingBroker?: string // required when Route Type is AWAY & Market is OTC
    orderId?: string //required only for execution type
  }
  version: number
}
export interface SpecialInstruction {
  value?: SpecialInstructionsEnum
  id: string
}

export interface LotMatchingInstruction {
  tradeDate?: string
  price?: number
  quantity?: number
  id: string
}

export enum SpecialInstructionsEnum {
  RULE_144 = 'RULE_144',
  WITH_DIVIDEND = 'WITH_DIVIDEND',
  WITH_RIGHTS = 'WITH_RIGHTS',
  CLOSE_CONTRACT = 'CLOSE_CONTRACT',
  COVER_SHORT = 'COVER_SHORT',
  CROSS_TRADE = 'CROSS_TRADE',
  OPEN_CONTRACT_COVERED = 'OPEN_CONTRACT_COVERED',
  DISCRETION_EXERCISED = 'DISCRETION_EXERCISED',
  DISCRETION_NOT_EXERCISED = 'DISCRETION_NOT_EXERCISED',
  WHEN_DISTRIBUTED = 'WHEN_DISTRIBUTED',
  OPTION_ASSIGNMENT = 'OPTION_ASSIGNMENT',
  EMPLOYEE_STOCK_OPTION = 'EMPLOYEE_STOCK_OPTION',
  INVESTMENT_BANKING = 'INVESTMENT_BANKING',
  BROKER_DEALER_ORDER = 'BROKER_DEALER_ORDER',
  MAKE_MARKET_IN_SECURITY = 'MAKE_MARKET_IN_SECURITY',
  MAKE_MARKET_SOLICITED = 'MAKE_MARKET_SOLICITED',
  MAKE_MARKET_UNSOLICITED = 'MAKE_MARKET_UNSOLICITED',
  CUSTOMER_DIRECTED = 'CUSTOMER_DIRECTED',
  FULLY_REGISTERED = 'FULLY_REGISTERED',
  OPEN_CONTRACT = 'OPEN_CONTRACT',
  ODDLOT_DIFF_ON_REQUEST = 'ODDLOT_DIFF_ON_REQUEST',
  PROSPECTUS_ENCLOSED = 'PROSPECTUS_ENCLOSED',
  PROSPECTUS_SEPARATE_MAIL = 'PROSPECTUS_SEPARATE_MAIL',
  SHORT = 'SHORT',
  SOLICITED = 'SOLICITED',
  UNSOLICITED = 'UNSOLICITED',
  X_DIVIDEND = 'X_DIVIDEND',
}
